<template>
  <component :is="tag" ref="rootEl" :class="{ open: isOpen }">
    <slot :is-open="isOpen" :toggle="toggle" :open="open" :close="close" />
  </component>
</template>

<script>
export default {
  name: 'Dropdown',
  props: {
    tag: { type: String, default: 'div' }
  },
  data() {
    return { isOpen: false }
  },
  mounted() {
    document.addEventListener('click', this.onDocumentClick, true)
    document.addEventListener('keydown', this.onKeydown)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.onDocumentClick, true)
    document.removeEventListener('keydown', this.onKeydown)
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen
    },
    open() {
      this.isOpen = true
    },
    close() {
      this.isOpen = false
    },
    onDocumentClick(event) {
      if (this.isOpen && this.$refs.rootEl && !this.$refs.rootEl.contains(event.target)) {
        this.close()
      }
    },
    onKeydown(event) {
      if (this.isOpen && event.key === 'Escape') this.close()
    }
  }
}
</script>
